export const mailChimpApiKey = '70432031f556f1a7c993d148c6e1d955-us17';
export const mailChimpAudienceId = '3a22bd2e24';
export const mailChimpUrl =
	'https://gmail.us17.list-manage.com/subscribe/post?u=e01bf7609ed7875520e383792&amp;id=3a22bd2e24';
